import {ModaleLayout} from '@/components/Modale/ModaleLayout';
import {ProduitPanierErrorCommun} from '@/domains/panier/PanierFound/ProduitPanier/ProduitPanierErrorCommun';
import NiceModal from '@ebay/nice-modal-react';
import {HaliRenderAll} from '@synako/haligator';
import {FollowPromiseOne} from '@synako/halitrek';
import {LigneDePanierDesc} from 'api-types/ffconnect-hal';
import {LigneProblem} from 'api-types/ffconnect';
import {useTranslation} from 'react-i18next';

interface ModaleErreurStockMarketplaceProps {
  stock: number;
  ligneDePanier: FollowPromiseOne<LigneDePanierDesc>;
  onProductClick?: (code_article: string) => void;
}

export const ModaleErreurStockMarketplace = NiceModal.create(
  ({
    stock,
    ligneDePanier,
    onProductClick,
  }: ModaleErreurStockMarketplaceProps) => {
    const {t} = useTranslation();
    const modal = NiceModal.useModal();

    const clearAndClose = () => {
      modal.remove();
    };

    const probleme: LigneProblem = {
      problem: {
        code: stock === 0 ? 'rupture' : 'quantite_trop_importante',
        quantite_max: stock,
        instancePath: '',
        message: '',
        pour: 'ligne_de_commande',
        niveau: 'bloquant',
      },
      ligne_de_panier_id: '',
    };

    return (
      <ModaleLayout
        visible={modal.visible}
        hide={clearAndClose}
        titre={t('ligne_produit.indisponible.produit_indisponible_short')}
      >
        <HaliRenderAll
          all={[ligneDePanier, ligneDePanier.follow('item_2')]}
          render={({states: [ligneDePanierState, itemState]}) => {
            if (!ligneDePanierState) return;
            return (
              <ProduitPanierErrorCommun
                context='modale'
                probleme={probleme}
                idError='error'
                ligneDePanier={ligneDePanierState}
                onClose={clearAndClose}
                multipleCommandeClient={
                  itemState?.data.multiple_de_commande_client
                }
                onProductClick={onProductClick}
                itemState={itemState}
              />
            );
          }}
        />
      </ModaleLayout>
    );
  },
);
